import { css } from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
const styles = css `
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 100%;

  .grey-section {
    width: 100%;
    padding: 48px;
    background-color: ${newColors.gray100};
    ${mediaq.md `
      padding: 24px;
    `}
    ${mediaq.sm `
      padding: 20px;
    `}
  }
  .support-messages {
    margin-top: 48x;
  }

  .eventHeader {
    display: none;
    text-align: center;
    font-weight: 100;
    margin-top: 40px;
    margin-bottom: 20px;
    line-height: 35px;
  }

  &.miniView {
    position: fixed;
    bottom: 5px;
    right: 10px;
    z-index: 9;
    box-sizing: border-box;
    padding: 5px;
    background-color: ${newColors.snow};
    height: auto;
    #mediaPlayer {
      width: 200px !important;
      height: 150px !important;
    }
  }
  &.disabled {
    display: none;
  }
  #mediaPlayer {
    width: 100%;
    height: 100%;
    .player-error {
      background-color: ${newColors.black};
      color: ${newColors.snow};
      font-size: 20px;
      font-weight: bold;
      width: 100%;
      aspect-ratio: 16/9;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      .warning-icon {
        margin-right: 8px;
      }
      .error-message {
        display: flex;
        flex-direction: row;
        .warning-icon {
          margin-right: 8px;
          margin-top: 6px;
        }
      }
    }
    #jwplayer-0 {
      &.jw-flag-fullscreen {
        &.jwplayer .jw-media video {
          top: 78px;
          height: calc(100% - 78px);
        }
        .afs_ads.ad-placement {
          width: 100% !important;
          height: 100px !important;
          top: 0 !important;
          left: 0 !important;
        }
        .jw-controls .jw-controlbar .jw-button-container {
          height: 44px;
          padding: 0 12px;
          .jw-icon-inline {
            height: 44px;
            width: 44px;
          }
        }
        .jw-controlbar .jw-slider-horizontal.jw-chapter-slider-time {
          height 16px;
          padding: 0 12px;
        }
        .jw-slider-horizontal.jw-chapter-slider-time .jw-slider-container .jw-knob {
          top: unset;
        }
        .player-header.mobile-header {
          visibility: visible;
        }
      }
    }
    .jw-skin-oneroom {
      margin: 0 auto;
      font-family: 'Inter Variable', sans-serif !important;
      font-weight: 400;
      .jw-icon-rewind {
        display: none;
      }
      &.jw-reset,
      .jw-reset {
        font-family: 'Inter Variable', sans-serif !important;
        font-weight: 400;
      }
      .jw-display-container.jw-reset {
        display: flex;
        height: 100%;
      }
      &:focus {
        outline: none;
      }
      .jw-background-color {
        /* Use this class to set a global background color for all elemnts. */
        background: transparent;
      }
      &.jw-error,
      &.jw-state-error {
        width: 100% !important;
        height: 100% !important;

        .jw-error-msg {
          display: none !important;
        }
        #errSubHeading {
          position: absolute;
          display: flex;
          justify-content: center;
          background-color: transparent;
          width: 100%;
          top: 40%;
          left: auto;
          transform: translateY(-50%);
        }
      }
      & > .jw-title {
        display: none !important;
        background-color: ${newColors.gray800};
        box-sizing: border-box;
        padding: 16px;
        .jw-title-primary {
          padding: 0;
          margin-bottom: 16px;
          font-size: 18px;
        }
        .jw-title-secondary {
          padding: 0;
        }
      }
      .alert {
        padding: 0;
      }
      .jw-controls .jw-display {
        display: table;
        background: rgba(0, 0, 0, 0.3);

        ${mediaq.sm `
          display: flex;
          z-index: 1;
        `}
      }
      &.camera-open {
        .jw-display {
          display: none !important;
        }
      }
    }
    &.jw-state-error {
      .jw-settings-menu {
        bottom: 0;
      }
    }

    .jw-settings-menu {
      background-color: ${newColors.snow};
      bottom: 69px;

      .jw-settings-topbar {
        background: ${newColors.gray100};
        .jw-button-color {
          color: ${newColors.purple500};
        }
      }
      .jw-settings-submenu {
        padding: 0;
        &::-webkit-scrollbar {
          width: 10px;
        }
        &::-webkit-scrollbar-track {
          // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          border-radius: 10px;
          background-color: ${newColors.clear};
        }
        &::-webkit-scrollbar-thumb {
          background-color: ${newColors.purple500};
          border: none;
          border-radius: 6px;
        }
        .jw-settings-content-item {
          color: ${newColors.fontDefaultColor};
          padding: 10px 15px;
          &:hover {
            background-color: ${newColors.gray100};
          }
          &.jw-settings-item-active {
            color: ${newColors.fontDefaultColor};
            &::before {
              color: ${newColors.purple500}
            }
            font-weight: 500;
          }
        }
      }
    }
    .jw-controlbar {
      display: flex;
      font-family: 'Inter Variable', sans-serif;
      background-color: ${newColors.transparent15};
      margin: 0;
      .jw-button-container {
      }
    }
    .jw-button-container {
      flex: none;
      .jw-spacer {
        // background-color: red;
      }
      .jw-icon-cc {
        display: none !important;
      }
    }

    .jw-group {
      vertical-align: middle; /* Vertically aligns the timeslider and icons in the center of the controlbar. */
    }

    .jw-playlist {
      /* Sets the style for the visual playlist. */
      background-color: rgba(0, 0, 0, 0.8);
    }

    .jw-playlist-container {
      /* Aligns the visual playlist above its icon. */
      left: -43%;
      background-color: rgba(0, 0, 0, 0.8);

      .jw-option {
        /* Sets the style for the visual playlist items. */
        border-bottom: 1px solid #444;
      }

      .jw-option:hover,
      .jw-option.jw-active-option {
        /* Allows you to adjust the color of the playlist item when hovering and has a different active style.*/
        background-color: black;
      }

      .jw-option:hover {
        .jw-label {
          /* Changes the color of the label when hovering.*/
          color: ${newColors.gray100};
        }
      }
      .jw-icon-playlist {
        /* Aligns the playlist header icon with the items in the playlist. */
        margin-left: 0;
      }
      .jw-label {
        .jw-icon-play {
          /* Sets the color of the play icon of the currently playing playlist item.*/
          color: ${newColors.gray100};
          &:before {
            /* Aligns the playlist play icon with the items in the playlist. */
            padding-left: 0;
          }
        }
      }
      .jw-tooltip-title {
        /* Sets the color of the playlist title */
        background-color: #000;
        color: #fff;
      }
      .jw-text {
        font-family: 'Inter Variable', sans-serif;
        color: #ffffff; /* Style for playlist item, current time, qualities, and caption text.*/
      }
      .jw-button-color {
        /* Color for all buttons when they are inactive. This is over-ridden with the inactive configuration in the skin block.*/
        color: #ffffff;
        &:hover {
          /* Color for all buttons for when they are hovered on. This is over-ridden with the active configuration in the skin block.*/
          color: ${newColors.gray100};
        }
      }
      .jw-toggle {
        /* Color for when HD/CD icons are toggled on. */
        color: ${newColors.gray100};
        &.jw-off {
          /* Color for when HD/CD icons are toggled off. */
          color: #ffffff;
        }
      }
      .jw-controlbar {
        /* Sets spacing between controlbar icons and text */
        .jw-icon:before {
          padding: 0.7em;
        }
        .jw-text-elapsed,
        .jw-text-duration {
          padding: 0 0.7em;
        }
        .jw-icon-prev:before {
          /* Removes icon padding to align the playlist header icon with the items in the playlist. */
          padding-right: 0.25em;
        }
        .jw-icon-playlist {
          /* Removes icon padding to align the playlist header icon with the items in the playlist. */
          &:before {
            padding: 0 0.45em;
          }
        }
        .jw-icon {
          &:before {
            padding-left: 0.25em;
          }
        }
        .jw-icon-prev,
        .jw-icon-next {
          /* Sets the style for the prev and next icons. */
          font-size: 0.7em;
        }
        .jw-icon-prev {
          &:before {
            /* Adds the spacer style to between the play icon and the previous icon. */
            border-left: 1px solid ${newColors.gray500};
          }
        }
        .jw-icon-next {
          &:before {
            /* Adds the spacer style to between the next item and current time.  */
            border-right: 1px solid ${newColors.gray500};
          }
        }
        .jw-icon-display {
          /* Color of the display icon */
          color: #fff;
          &:before {
            /* Centers the display icon in it's container */
            padding-left: 0;
          }
        }
      }
    }

    #overlay-title {
      color: ${newColors.snow};
      position: absolute;
      margin: auto;
      top: 6vw;
      left: 0;
      bottom: 0;
      right: 0;

      #overlay-main-title,
      #overlay-sub-title {
        height: 4vw;
      }

      #overlay-main-title {
        font-size: 4vw;
      }

      #overlay-sub-title {
        font-size: 2.5vw;
      }
      ${mediaq.sm `
            display: none;
      `}
    }

    .jw-display-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .jw-display-icon-container {
      /* Turns the display icon container into a circle. */
      border-radius: 60px;
      // border: 1px solid #333;
      background-color: ${newColors.snow};
      svg {
        color: ${newColors.transparent30};
      }
      .jw-display,
      .jw-icon-display {
        width: 100px;
        height: 100px;
      }
      .jw-svg-icon {
        width: 80px;
        height: 80px;
      }
    }

    /* Styles the timeslider rail */
    .jw-rail {
      background: rgba(255, 255, 255, 0.3);
      box-shadow: none;
    }

    /* Sets the color for the buffer of the timeslider rail. */
    .jw-buffer {
      background-color: ${newColors.clear};
    }

    /* Sets the style for the elaspesd progress. */
    .jw-progress {
      background: ${newColors.snow};
    }

    /* Sets the width of the knob's container */
    .jw-knob {
      width: 0.6em;
      height: 0.6em;
      background-color: #fff;
      border-radius: 1em;
    }
    .jw-flag-fullscreen {
      .jw-slider-horizontal {
        .jw-knob {
          ${mediaq.lg `
          top: unset !important;
        `}
        }
      }
    }

    /* Sets the height for the horizontal slider container. */
    .jw-spacer {
      width: 20px;
    }

    .jw-display-icon-next,
    .jw-display-icon-rewind {
      display: none;
    }

    .jw-icon-fullscreen {
      z-index: 100;
    }

    .jw-slider-horizontal {
      .jw-rail,
      .jw-buffer,
      .jw-progress {
        height: 0.2em;
        border-radius: 0;
      }

      /* Centers the knob vertically. */
      .jw-knob {
        top: -0.19999999999999998em;
      }

      /* Centers the timeslider cuepoints vertically. */
      .jw-cue {
        top: -0.04999999999999999em;
        width: 0.3em;
        height: 0.3em;
        background-color: #fff;
        border-radius: 50%;
      }

      &.jw-chapter-slider-time {
        background: none;

        &.liveStreaming {
          display: none !important;
        }
        .jw-slider-container {
          .jw-rail {
            top: 0;
            height: 5px;
            transform: translate(0, 0) scale(1, 1);
            background: rgba(255, 255, 255, 0.3);
          }
          .jw-buffer {
            top: 0;
            height: 5px;
            transform: translate(0, 0) scale(1, 1);
          }
          .jw-progress {
            top: 0;
            height: 5px;
            transform: translate(0, 0) scale(1, 1);
            background-color: ${newColors.snow};
          }
          .jw-knob {
            top: 3px;
            width: 0.8em;
            height: 0.8em;
            border: none;
            background-color: ${newColors.snow};
            box-shadow: none;
            /* border-radius:50%; */
            transform: translate(-8px, -1px) scale(1, 1);
          }
          &:hover {
            .jw-flag-fullscreen {
              .jw-knob {
                top: 9px;
              }
            }
          }
        }
        ${mediaq.md `
          height: 10px;
        `}
      }
    }

    /* Sets the width for the vertical slider elements. */
    .jw-slider-vertical {
      .jw-rail,
      .jw-buffer,
      .jw-progress {
        width: 0.2em;
      }
    }

    /* Sets the position of the volume slider container. */
    .jw-volume-tip {
      width: 100%;
      left: -45%;
      padding-bottom: 0.7em;
      border: none;
      background-color: ${newColors.transparent15};
    }

    /* Sets the color of the duration text in the controlbar. */
    .jw-text-duration {
      color: #666f82;
    }

    /* Adds a left border as a spacer between all controlbar icons. */
    .jw-controlbar-right-group {
      outline: yellow 1px solid;

      .jw-icon-tooltip:before,
      .jw-icon-inline {
        /* Removes the border from the first icon after the time duration text. */
        &:before {
          border-left: 1px solid ${newColors.gray500};
        }
        &:first-child:before {
          border: 0;
        }
      }
    }

    .jw-dock {
      /* This styles the dock icons into a circle. */
      .jw-dock-button {
        border-radius: 50%;
        border: 1px solid red;
      }
      /* This styles tooltip for dock text background. */
      .jw-overlay {
        border-radius: 2.5em;
        outline: 1px solid red;
      }
    }

    /* This sets the font color and background color for the active item in HD and CC menus. */
    .jw-icon-tooltip {
      .jw-active-option {
        background-color: ${newColors.purple500};
        color: #fff;
      }
    }

    /* Sets a min width for the volume container so that when it changes between mute and volume, the controlbar does not shift. */
    .jw-icon-volume {
      min-width: 2.6em;
      z-index: 2;
    }
    .jw-time-tip,
    .jw-menu,
    .jw-volume-tip,
    .jw-skip {
      border: 1px solid rgba(255, 255, 255, 0.25);
    }

    /* Sets the position for the time tooltip. */
    .jw-time-tip {
      padding: 0.2em;
      bottom: 1.3em;
    }

    /* Sets the position for the vertical volume slider. */
    .jw-menu,
    .jw-volume-tip {
      bottom: 0.24em;
    }

    /* Sets the shape of the skip icon. */
    .jw-skip {
      padding: 0.4em;
      border-radius: 1.75em /* Sets the style for the skip text. */ .jw-text, .jw-icon-inline {
        color: #fff;
        line-height: 1.75em;
      }
      &.jw-skip.jw-skippable:hover {
        .jw-text,
        .jw-icon-inline {
          color: ${newColors.purple500};
        }
      }
    }

    /* right click popup style*/
    .jw-rightclick {
      background-color: ${newColors.transparent15};

      .jw-rightclick-item {
        background-color: ${newColors.transparent15};
        font-size: 14px;
      }
      .jw-featured {
        outline: red 1px solid;
        display: none !important;
        /*visibility: hidden;*/
        display: none;
      }
    }

    /* background layer for oneroom custom submenu */
    .jw-icon {
      &.jw-text-live,
      &.jw-text-duration,
      &.jw-text-countdown,
      &.jw-text-elapsed {
        display: none;
        font-family: 'Inter Variable', sans-serif;
      }
    }
    .jw-icon.jw-icon-inline.jw-button-color.jw-reset.jw-logo-button {
      display: none;
    }
    .jw-icon-fullscreen:not(.jw-fullscreen-ima) {
      .jw-svg-icon-fullscreen-on,
      .jw-svg-icon-fullscreen-off {
        background-image: url('/assets/images/fullscreen.svg');
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    [button='switchCamera'] {
      opacity: 0.85;
      transition: opacity 0.3s ease;
      position: relative;
      & > .jw-button-image {
        max-height: none;
        width: 100%;
        background-size: 24px;
      }
      &:hover {
        opacity: 1;
      }
    }

    [button='logo'] {
      order: 99;
      width: 94px;
      opacity: 0.9;
      transition: opacity 0.3s ease;
      & > .jw-button-image {
        max-height: none;
        width: 100%;
      }
      &:hover {
        opacity: 1;
      }
    }

    .tutBubble {
      font-family: 'Inter Variable', sans-serif;
      position: absolute;
      top: calc(-100% - 20px);
      left: 50%;
      background-color: ${newColors.purple500};
      padding: 16px;
      font-size: 14px;
      opacity: 0;
      animation: pop 5s 1 -1s;
      &#tut-fullscreen {
        animation-delay: 3s;
      }
      &#tut-helpCenter {
        animation-delay: 6s;
      }
    }
    #submenu-switchCamera {
      position: relative;
      align-items: flex-start;
      width: 100%;
      background-color: ${newColors.purple500};
      pointer-events: auto;
      opacity: 0;
      transform: translate(0, 100%);
      z-index: -1;
      font-size: 14px;

      /* when close dropdown */
      transition: opacity 0.5s ease, transform 0.7s 0.2s ease-in-out;
      ${mediaq.md `
        /*max-width: 304px;
        width: 90%;*/
      `}

      &.tutorialOn {
        z-index: 999;
        opacity: 1;
        transform: translate(0, 0);
        /* when open dropdown */
        transition: transform 3s, opacity 3s 2s ease-in-out;

        .contentHeading.collapse div:first-of-type {
          span {
            text-transform: lowercase;
            &:before {
              content: 'You can ';
              text-transform: initial;
            }
            &:after {
              content: '!';
              text-transform: initial;
            }
          }
        }
        .contentBody.collapse {
          display: none;
        }
      }

      ${mediaq.md `
        transform: translateX(0);
      `}
      &.active {
        z-index: 999;
        opacity: 1;
        transform: translate(0, 0);
        /* when open dropdown */
        transition: transform 0.5s ease, opacity 0.7s 0.2s ease-in-out;
        .contentHeading div:first-of-type {
          span {
            text-transform: initial !important;
            &:before {
              content: none !important;
            }
            &:after {
              content: none !important;
            }
          }
        }
        .contentBody {
          display: block !important;
          ${mediaq.md `
            display: flex !important;
          `}
        }
      }
    }

    @keyframes popTutorial {
      0% {
        opacity: 0;
        transform: translate(0, 100%);
      }
      5% {
        opacity: 0;
        z-index: -1;
      }
      15% {
        transform: translate(0, 0);
      }
      30% {
        opacity: 1;
        z-index: 999;
      }
      60% {
        opacity: 1;
        z-index: 999;
        transform: translate(0, 0);
      }
      70% {
        transform: translate(0, 0);
      }
      80% {
        opacity: 0;
        z-index: -1;
      }
      100% {
        opacity: 0;
        transform: translate(0, 100%);
      }
    }

    @keyframes pop {
      0% {
        opacity: 0;
        transform: translate(0, 100%);
      }
      5% {
        opacity: 0;
        z-index: -1;
      }
      15% {
        transform: translate(0, 0);
      }
      30% {
        opacity: 1;
        z-index: 999;
      }
      60% {
        opacity: 1;
        z-index: 999;
        transform: translate(0, 0);
      }
      70% {
        transform: translate(0, 0);
      }
      80% {
        opacity: 0;
        z-index: -1;
      }
      100% {
        opacity: 0;
        transform: translate(0, 100%);
      }
    }
  }

  #mediaPlayer {
    position: relative;
  }

  .player-header {
    z-index: 5;
    width: 100%;
    min-height: 50px;
    background: ${newColors.gray800};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;

    ${mediaq.sm `
      flex-direction: column;
      align-items: flex-end;
      padding: 5px 20px;
    `}


    &.mobile-header {
      position: absolute;
      top: 0;
      visibility: hidden;

      ${mediaq.sm `
        flex-direction: row;
        align-items: center;
        padding: 5px;
      `}
    }

    &.mobile-banner {
      display: none;

      ${mediaq.sm `
        display: flex;
        flex-direction: row;
      `}
    }

    .player-header-container {
      display: flex;
      align-items: center;
      flex: 1;
      flex-direction: row;
      justify-content: flex-start;
    }

    .player-header-column {
      display: flex;
      align-items: center;
      gap: 4px;
      flex: 1;
      flex-direction: row;
      &.middle-column {
        justify-content: center;
      }
      &.last-column {
        display: flex;
        justify-content: flex-end;
      }

      ${mediaq.sm `
        display: none;
      `}
    }

    .title {
      color: ${newColors.snow} !important;
      line-height: 1.5;
      min-width: fit-content;

      &:first-of-type {
        font-weight: 600;
      }
    }

    .logo {
      width: 41px;
      height: 41px;
      padding: 1.25px;
      border-radius: 50%;

      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
    }

    .title-container {
      display: inline-flex;
      gap: 10px;
      flex-direction: row;
      color: ${newColors.snow};
      font-size: 12px;
      margin: 0 0px 0 10px;

      }

      .heading {
        line-height: 1.5;
        min-width: fit-content;
      }
    }

    .controls-button,
    .support-button {
      padding: 9px;

      ${mediaq.sm `
        padding: 5px;
      `}

      button {
        font-size: 12px;
        padding: 8px 10px;
        width: auto;

        ${mediaq.sm `
          padding: 6px;
        `}
      }
      button + button {
        margin-left: 5px;
      }
    }

    .controls-button {
      padding: 0;
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }

    .mobile-header-button {
      background: ${newColors.gray100};
      color: ${newColors.gray500};
      white-space: nowrap;
      border-radius: 6px;
      cursor: pointer;
      border: none;
      opacity: 1;
      transition: opacity 300ms ease 0s;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 8px 10px;
      height: 40px;
      font-size: 16px;
      line-height: 24px;
      ${mediaq.md `
      font-size: 14px;
      line-height: 22px;
      `}
      &:hover {
        opacity: 0.5;
      }
      &.not-selected {
        background: ${newColors.gray500};
        color: ${newColors.gray100};
      }

      .icon.left {
        margin-right: 10px;
      }

      .icon.right {
        margin-left: 10px;
      }
    }

    .tech-support-container {
      font-family: 'Inter Variable', sans-serif;
      display: none;
      position: absolute;
      top: 90px;
      right: 10px;
      box-shadow: 0px 4px 20px 0px ${newColors.darkBlueAlpha12};
      border-radius: 18px;
      flex-direction: column;
      align-items: flex-start;
      z-index: 9;
      &.tech-support-visible {
        display: block;
      }
      .tech-support-inner-container {
        background-color: ${newColors.snow};
        border-radius: 16px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        .tech-support-block {
          border-bottom: 1px solid ${newColors.gray100};
          padding: 16px;
        }
        .tech-support-row {
          display: flex;
          flex-direction: row;
          width: 100%;
          .tech-support-icon-container {
            display: flex;
            width: 38px;
            height: 38px;
            border-radius: 50px;
            background-color: ${newColors.gray};
            img {
              display: block;
              margin: auto;
            }
          }
          .tech-support-message {
            flex: 3;
            color: ${newColors.gray800};
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
          }
        }
        .tech-support-link {
          text-decoration: none;
          &:hover {
            text-decoration: none;
          }
        }
        .tech-support-button {
          cursor: pointer;
          display: flex;
          flex-direction: row;
          padding: 10px 16px;
          background: ${newColors.purple500};
          border-radius: 30px;
          font-family: 'Inter Variable', sans-serif;
          font-weight: 600;
          font-size: 12px;
          line-height: 22px;
          color: ${newColors.snow};
          border: none;
        }
        .tech-support-footer {
          padding: 16px;
          .tech-support-phrase {
            font-family: 'Inter Variable', sans-serif;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            color: ${newColors.gray800};
            margin: 0;
            padding: 0;
            a {
              color: ${newColors.purple500};
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
`;
export default styles;
